import { axios } from './config';

export const getVastTagPartnerMappings = () => axios.get('/cb/vastTagPartnerMappings');
